import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Page } from "../../components/page/page";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { StatusMessage } from "../../components/status-message/statusMessage";
import { OtpForm } from "./form";
import { useNetwork } from "../../hooks/useNetwork/useNetwork";
import { getErrorText } from "../../util/error/getErrorText";

export const OtpKey: React.FC = () => {
  const { localize } = useLocalization();
  const { network, loading } = useNetwork();
  const [validated, setValidated] = useState<boolean>(false);
  const [key, setKey] = useState<string>("");
  const [error, setError] = useState<string>("");

  const fetchKey = useCallback(async () => {
    try {
      const { key } = await network<{ key: string }>("/otp/key");
      setKey(key);
    } catch (error) {
      setError(
        getErrorText(error, {
          400: localize("otp:key:badRequest"),
        }),
      );
    }
  }, [network]);

  useEffect(() => {
    fetchKey();
  }, [fetchKey]);

  return (
    <Page title={localize("otp:title")}>
      {validated ? (
        <StatusMessage type="success">OK</StatusMessage>
      ) : (
        <>
          <ol className="h4">
            <li>{localize("otp:key:step1")}</li>
            <li>{localize("otp:key:step2")}</li>
            <li>{localize("otp:key:step3")}</li>
            <li>{localize("otp:key:step4")}</li>
          </ol>
          <StatusMessage>{localize("otp:key:description")}</StatusMessage>
          {error && <StatusMessage type="error">{error}</StatusMessage>}
          <p className="h4 centered">{loading ? "Laster nøkkel…" : key}</p>
          <OtpForm onValidate={() => setValidated(true)} />
        </>
      )}
      <Link className="button secondary" to="../" relative="path">
        {localize("back")}
      </Link>
    </Page>
  );
};
